<template>
    <div class="row mt-3">
        <div class="col-12">
            <TitleComponent title="4. Confirmación de compra" subtitle=""></TitleComponent>
        </div>
        <div class="col-12">
            <ListadoAbonosComponent :abonos="datos_compradores" :datos_compra="datos_compra" :urls_imprimir="urls_imprimir"></ListadoAbonosComponent>
        </div>
        <div class="col-12 mt-3" v-if="!compra_finalizada">
            <div class="row">
                <div class="col-12" v-if="!loading">
                    <Button class="btn-block" :disabled="loading" @click.prevent="procesarCompra">FINALIZAR COMPRA</Button>
                </div>
                <div class="col-12" v-else>
                    <LoaderComponent></LoaderComponent>
                </div>
            </div>

        </div>
        <template v-if="compra_finalizada">
            <div class="col-12 mt-3">
                <div class="alert alert-success" role="alert">
                    Compra finalizada <Button :href="url_factura" target="blank_">IMPRIMIR RECIBO</Button>
                </div>
            </div>
            <div class="col-12 mt-3">
                <Button class="btn-block" @click.prevent="reiniciar">Volver</Button>
            </div>
        </template>
    </div>
</template>

<script>
    import TitleComponent from '@/components/backend/stepper/components/TitleComponent';
    import ListadoAbonosComponent from '@/components/backend/stepper/components/ListadoAbonosComponent';

    export default {
        props: ['datos_compradores', 'datos_compra'],
        data() {
            return {
                compra_finalizada: false,
                loading: false,
                urls_imprimir: [],
                url_factura: []
            }
        },
        methods: {
            procesarCompra() {
                this.loading = true;
                const params = {
                    zona_id: this.datos_compradores[0].area.id,
                    numero_entradas: this.datos_compradores.length,
                    metodo_pago: this.datos_compra.metodo_pago.valor,
                    descuento_aplicado: {
                        valor: this.datos_compra.descuento_aplicado
                    },
                    datos_compradores: this.datos_compradores
                };
                this.$store.dispatch(this.config.getVuexAlias('back.abonados.alta'), params).then(res => {
                    this.compra_finalizada = true;
                    this.urls_imprimir = res.data.urls_imprimir;
                    this.url_factura = res.data.url_factura;
                    this.loading = false;
                });
            },
            reiniciar() {
                this.$emit('reiniciar');
            }
        },
        components: {
            TitleComponent, ListadoAbonosComponent
        }
    }
</script>
